import template from './forgot-password.html';
import controller from './forgot-password.controller';

let forgotPasswordComponent = {
  restrict: 'E',
  bindings: {},
  template,
  controller
};

export default forgotPasswordComponent;
